import { setToken } from './handleToken';

export function bootstrapAutoLogin(): void {
	if (typeof window === 'undefined') return;

	const hash = window.location.hash.slice(1); // '#' 제거
	if (!hash) return;

	const params = new URLSearchParams(hash);
	const accessToken = params.get('accessToken');
	if (!accessToken) return;

	const route = params.get('route');

	sessionStorage.removeItem('policy_checking');
	sessionStorage.removeItem('policy_check_done');
	sessionStorage.removeItem('has_redirected_after_login');

	/**
	 * URL 로그인은 accessToken 만 전달받으므로 이전 세션의 refreshToken 을 제거한다.
	 * 남겨두면 accessToken 만료 시 이전 계정의 refreshToken 으로 갱신되어
	 * 사용자 모르게 이전 계정 세션으로 되돌아간다.
	 */
	localStorage.removeItem('refreshToken');

	setToken(accessToken);

	const destination = route === 'client' ? '/stats/period' : window.location.pathname || '/';

	history.replaceState(null, '', destination + window.location.search);
}
